<div class="dialog addToCollection">

        <div class="dialog-title">
            <h2 mat-dialog-title>
                @if(editMode) {
                    {{'editProfile.hl' | translate}}
                }
                @if(!editMode) {
                    {{'createNewUser' | translate}}
                }

            </h2>
            <button mat-icon-button (click)="close()">
                <mat-icon  fontIcon="close"></mat-icon>
            </button>
        </div>
    <form [formGroup]="userForm">
        <mat-dialog-content>

                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.userName'| translate}}</mat-label>
                            <input matInput  formControlName="username">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.email'| translate}}</mat-label>
                            <input matInput  formControlName="email" aria-describedby="emailRequired emailInvalid">
                        </mat-form-field>
                        @if(userForm.controls['email'].invalid && (userForm.get('email')?.touched || userForm.controls['email'].dirty)) {
                            @if(userForm.controls['email'].hasError('required')) {
                                <div class="error" id="emailRequired" role="alert">{{'error.required' | translate}}</div>
                            }
                            @if(userForm.controls['email'].hasError('email')) {
                                <div class="error" id="emailInvalid" role="alert">{{'error.emailInvalid' | translate}}</div>
                            }
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.firstName'| translate}}</mat-label>
                            <input matInput  formControlName="firstName" aria-describedby="firstNameRequired">
                        </mat-form-field>
                        @if(userForm.controls['firstName'].invalid && (userForm.get('firstName')?.touched || userForm.controls['firstName'].dirty)) {
                            @if(userForm.controls['firstName'].hasError('required')) {
                                <div class="error" id="firstNameRequired" role="alert">{{'error.required' | translate}}</div>
                            }
                        }
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.lastName'| translate}}</mat-label>
                            <input matInput  formControlName="lastName" aria-describedby="lastNameRequired">
                        </mat-form-field>
                        @if(userForm.controls['lastName'].invalid && (userForm.get('lastName')?.touched || userForm.controls['lastName'].dirty)) {
                            @if(userForm.controls['lastName'].hasError('required')) {
                                <div class="error" id="lastNameRequired" role="alert">{{'error.required' | translate}}</div>
                            }
                        }
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.jobTitle'| translate}}</mat-label>
                            <input matInput  formControlName="jobTitle">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.company' | translate}}</mat-label>
                            <input matInput  formControlName="company">
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.department'| translate}}</mat-label>
                            <input matInput  formControlName="department">
                        </mat-form-field>
                    </div>
                    <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'editProfile.country'| translate}}</mat-label>
                            <mat-select formControlName="country">
                                @for(c of countries | keyvalue; track c ) {
                                    <mat-option [value]="c.key">{{c.value}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                   <!-- <div class="col-6">
                        <mat-form-field>
                            <mat-label>{{'user.roles' | translate}}</mat-label>
                            <mat-select formControlName="roles" multiple>
                                @for(role of roles; track role) {
                                    <mat-option [value]="role">{{role}}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>-->

                    <div class="col-6">
                        @if(!editMode) {
                            <mat-form-field>
                                <mat-label>{{'user.invitationInstance' | translate}}</mat-label>
                                <mat-select formControlName="invitationInstance">
                                    @for(entry of InvitationInstance | keyvalue; track entry) {
                                        <mat-option [value]="entry.key">{{entry.value}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                        }

                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-checkbox formControlName="passwordResetRequired">{{'user.passwordResetRequired' | translate}}</mat-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <mat-checkbox formControlName="isActive">{{'user.isActive' | translate}}</mat-checkbox>
                    </div>
                </div>
            <div class="row mb-3">
                <div class="col-12">
                     <h2>{{'Roles' | translate}}</h2>
                </div>
            </div>
            <div class="row">
                <!--<div class="col-6">
                    <mat-form-field>
                        <mat-label>{{'Role.user_type' | translate}}</mat-label>
                        <mat-select formControlName="userTypeRoles">
                            @for (role of groupUserType; track role) {
                                <mat-option [value]="role.name">{{role.description}}
                                @if(role.hint) {
                                    <span [innerHTML]="'<br>' + role.hint"></span>
                                    }</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>-->
                <div class="col-6">
                    <mat-form-field>
                        <mat-label>{{'Role.level' | translate}}</mat-label>
                        <mat-select formControlName="levelRoles">
                            @for (role of groupLevel; track role) {
                                <mat-option [value]="role.name">{{role.description}}
                                    @if(role.hint) {
                                        <span [innerHTML]="'<br>' + role.hint"></span>
                                    }</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-6">
                    <mat-form-field>
                        <mat-label>{{'Role.special_roles' | translate}}</mat-label>
                        <mat-select multiple formControlName="specialRoles">
                            @for (role of groupSpecial; track role) {
                                <mat-option [value]="role.name">{{role.description}}
                                    @if(role.hint) {
                                        <span [innerHTML]="'<br>' + role.hint"></span>
                                    }</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>

            </div>
            <div class="row">

                <div class="col-6">
                    <mat-form-field>
                        <mat-label>{{'Role.access' | translate}}</mat-label>
                        <mat-select multiple formControlName="accessRoles" #select>
                            @for (role of groupAccess; track role) {
                                <mat-option [value]="role.name">{{role.description}}
                                    @if(role.hint) {
                                        <span [innerHTML]="'<br>' + role.hint"></span>
                                    }</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <!--<div class="row">
                @for(role of data.availableRoles; track role) {
                    <div class="col-12 col-md-6">
                        <div class="col-12">
                            <mat-checkbox [(ngModel)]="role.selected" [ngModelOptions]="{standalone: true}">{{role.description}}</mat-checkbox>
                        </div>
                    </div>
                }
            </div>-->



        </mat-dialog-content>
        <mat-dialog-actions [align]="'center'">
            <div class="btn-row">
                <button mat-button type="button" (click)="close()">{{'button.cancel'|translate}}</button>
                <button mat-raised-button type="submit" (click)="save()"
                        [disabled]="!userForm.valid">{{'button.save'|translate}}
                </button>
            </div>
        </mat-dialog-actions>
    </form>

</div>

